/**
 * Browser → Railway AI proxy. The OpenAI key never leaves the backend.
 */
import api from '../config/api';

const AI_TIMEOUT_MS = 180000;

export async function chatCompletion({
  purpose,
  messages,
  model,
  maxTokens,
  temperature,
  presencePenalty,
  frequencyPenalty,
  responseFormat,
  tripId,
  usePartnerAuth = false,
} = {}) {
  const { data } = await api.post(
    '/ai/chat-completions',
    {
      purpose,
      messages,
      model,
      maxTokens,
      temperature,
      presencePenalty,
      frequencyPenalty,
      responseFormat,
      tripId,
    },
    {
      timeout: AI_TIMEOUT_MS,
      usePartnerAuth,
    }
  );

  if (!data?.content || typeof data.content !== 'string') {
    throw new Error('AI service returned an empty response');
  }

  return {
    content: data.content,
    usage: data.usage || null,
    model: data.model || model || null,
  };
}
